import React, {useState} from "react";
import ButtonContainer from "../../../../../components/Simple/ButtonContainer";
import SMCButton from "../../../../../components/Simple/SMCButton";
import SMCTable from "../../../../../components/core/SMCTable/SMCTable";
import {useTranslation} from "react-i18next";
import {useBoolean} from "../../../../../utils/hooks";
import TextInputModal from "../../../../PopupPages/TextInputModal";
import {validateEmailAddress} from "../../../../../utils/utils";

function EmailsTable({
                          disabled,
                          emailsList,
                          onChange
}) {

    const { t } = useTranslation();

    const [
        isAddEmailsModalOpen,
        openAddEmailsModal,
        closeAddEmailsModal,
    ] = useBoolean(false);

    const [selectedObjects, setSelectedObjects] = useState([]);

    const onAdd = (email) => {
        if (!validateEmailAddress(email)) {
            alert(t('com.sofaware.schema.ATTRIBUTE_INVALID_VALUE_EMAIL', [email, t('SMC_USER_EMAIL')]));
            return;
        }

       onChange([...emailsList, email])
       closeAddEmailsModal();
    }

    const onDelete = () => {
        const recipientsToDelete = selectedObjects;
        const emailsListAfterDelete = emailsList.filter(email => !recipientsToDelete.includes(email));
        onChange(emailsListAfterDelete)
    }

    return (
        <>
            <ButtonContainer>
                <SMCButton
                    variant="ghost"
                    disabled={disabled}
                    icon="new"
                    onClick={openAddEmailsModal}>
                    {t("SMC_GEN_NEW")}
                </SMCButton>
                <SMCButton
                    variant="ghost"
                    disabled={disabled || !selectedObjects.length}
                    icon="delete"
                    onClick={onDelete}
                >
                    {t("SMC_GEN_DELETE")}
                </SMCButton>
            </ButtonContainer>
            <SMCTable
                columns={[
                    {
                        id: "email",
                        accessor: "email",
                        header: t("SMP.EMAIL"),
                        width: 200
                    }
                ]}
                rowIdSelector={(obj) => obj['email']}
                selectedObjects={selectedObjects}
                setSelectedObjects={setSelectedObjects}
                hasCheckAll={true}
                content={emailsList.map(email => ({email: email}))}
                width={500}
                maxHeight={500}
            />
            <TextInputModal
                isOpen={isAddEmailsModalOpen}
                onSuccess={onAdd}
                title={t("SMP.PLAN.SERVICES.REPORT_RECIPIENTS.ADD_EMAIL_MODAL.TITLE")}
                textInputLabel={t("SMP.PLAN.SERVICES.REPORT_RECIPIENTS.ADD_EMAIL_MODAL_LABEL")}
                width={400}
                labelWidth={100}
                onRequestClose={closeAddEmailsModal}
            />
        </>);
}

export default EmailsTable;